import React, { useState, FormEvent } from 'react'
import { useHistory } from 'react-router-dom'

import api from '../../services/api'

import Input from '../../components/Input'
import Header from '../../components/Header'
import Select from '../../components/Select'
import Textarea from '../../components/Textarea'

import warningIcon from '../../assets/images/icons/warning.svg'

import './styles.css'

const TeacherForm: React.FC = () => {
  const [name, setName] = useState('')
  const [avatar, setAvatar] = useState('')
  const [whatsapp, setWhatsapp] = useState('')
  const [bio, setBio] = useState('')

  const [subject, setSubject] = useState('')
  const [cost, setCost] = useState('')

  const [scheduleItems, setScheduleItems] = useState([
    { week_day: '', from: '', to: '' }
  ])

  const history = useHistory();

  const setScheduleItemsValue = (position: number, field: string, value: string) => {
    const updatedScheduleItems = scheduleItems.map((scheduleItem, index) => {
      if (index === position) {
        return { ...scheduleItem, [field]: value }
      }

      return scheduleItem
    })

    setScheduleItems(updatedScheduleItems)
  }

  const createClass = async (e: FormEvent) => {
    e.preventDefault()

    try {
      await api.post('/classes', {
        name, avatar, whatsapp, bio, subject, cost: Number(cost), schedule: scheduleItems
      })

      alert(`${name} cadastrado com sucesso!`)

      history.push('/')
    } catch (error) {
      alert(`Ocorreu um problema ao realizar o cadastro, tente novamente.\nErro: ${error.message}`)
    }
  }

  return (
    <div id="page-teacher-form" className="container">
      <Header
        title="Que incrível que você quer dar aulas."
        description="O primeiro passo é preencher esse formulário de inscrição"
      />

      <main>
        <form onSubmit={createClass}>
          <fieldset>
            <legend>Seus dados</legend>

            <Input
              name="name"
              label="Nome completo"
              value={name}
              onChange={e => setName(e.target.value)}
            />
            <Input
              name="avatar"
              label="Avatar"
              value={avatar}
              onChange={e => setAvatar(e.target.value)}
            />
            <Input
              name="whatsapp"
              label="Whatsapp"
              value={whatsapp}
              onChange={e => setWhatsapp(e.target.value)}
            />
            <Textarea
              name="bio"
              label="Biografia"
              value={bio}
              onChange={e => setBio(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>Sobre a aula</legend>

            <Select
              name="subject"
              label="Metéria"
              options={[
                { value: 'Artes', label: 'Artes' },
                { value: 'Biologia', label: 'Biologia' },
                { value: 'Educação Física', label: 'Educação Física' },
                { value: 'Espanhol', label: 'Espanhol' },
                { value: 'Filosofia', label: 'Filosofia' },
                { value: 'Física', label: 'Física' },
                { value: 'Geografia', label: 'Geografia' },
                { value: 'História', label: 'História' },
                { value: 'Inglês', label: 'Inglês' },
                { value: 'Língua Portuguesa', label: 'Língua Portuguesa' },
                { value: 'Literatura', label: 'Literatura' },
                { value: 'Matemática', label: 'Matemática' },
                { value: 'Química', label: 'Química' },
                { value: 'Sociologia', label: 'Sociologia' }
              ]}
              value={subject}
              onChange={e => setSubject(e.target.value)}
            />
            <Input
              name="cost"
              label="Custo por hora de aula"
              value={cost}
              onChange={e => setCost(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>
              Horários disponíveis
            <button type="button" onClick={() =>
                setScheduleItems([...scheduleItems, {
                  week_day: '', from: '', to: ''
                }])
              }>
                + Novo Horário
            </button>
            </legend>

            {scheduleItems.map((item, index) =>
              <div key={index} className={`schedule-item ${index > 0 && 'hide-labels'}`}>
                <Select
                  name="week-day"
                  label="Dia da semana"
                  options={[
                    { value: '0', label: 'Domingo' },
                    { value: '1', label: 'Segunda-feira' },
                    { value: '2', label: 'Terça-feira' },
                    { value: '3', label: 'Quarta-feira' },
                    { value: '4', label: 'Quinta-feira' },
                    { value: '5', label: 'Sexta-feira' },
                    { value: '6', label: 'Sábado' },
                  ]}
                  value={item.week_day}
                  onChange={e => setScheduleItemsValue(index, 'week_day', e.target.value)}
                />
                <Input
                  name="from"
                  label="Das"
                  type="time"
                  value={item.from}
                  onChange={e => setScheduleItemsValue(index, 'from', e.target.value)}
                />
                <Input
                  name="to"
                  label="Até"
                  type="time"
                  value={item.to}
                  onChange={e => setScheduleItemsValue(index, 'to', e.target.value)}
                />
              </div>
            )}
          </fieldset>

          <footer>
            <p>
              <img src={warningIcon} alt="Aviso Importante" />
            Importante! <br />
            Preencha todos os dados
          </p>
            <button type="submit">
              Salvar cadastro
          </button>
          </footer>
        </form>
      </main>
    </div>
  )
}

export default TeacherForm